
<template>
   <v-layout row wrap>
      <v-flex class="xs12 sm4">
         <shdl-module-list
            :user="user"
            :teams="teams"
            :selectedModuleId="selectedModuleId"
            @moduleSelected="selectModule"
            @addModule="addModule"
            @deleteModule="deleteModule"
            @lockModule="lockModule">
        </shdl-module-list>
      </v-flex>

      <v-flex class="xs12 sm8">
         <router-view @userModuleUpdated="userModuleUpdated"></router-view>
      </v-flex>
   </v-layout>
</template>


<script>
   import ShdlModuleList from '@/components/shdl/ShdlModuleList'
   import { checkModule } from '@/utilities/shdl/shdlAnalyser.js'
   import moment from 'moment'

   export default {

      props: {
         userId: Number,
         baseRoute: String,
      },

      components: {
         ShdlModuleList: ShdlModuleList,
      },

      mounted: async function() {
         // fetch user SHDL modules in central store: reactivity will update the list view
         this.$store.dispatch('shdl/GET_SHDL_MODULES', { userId: this.userId, teamId: 0 })
         // fetch teams for which userId is a member
         let teams = await this.$store.dispatch('teams/GET_USER_TEAMS', this.userId)
         // for each team, fetch members & SHDL modules: reactivity will update the list view
         let self = this
         teams.forEach(function(team) {
            self.$store.dispatch('shdl/GET_SHDL_MODULES', { userId: 0, teamId: team.id })
            team.members.forEach(function(userId) {
               self.$store.dispatch('GET_USER', userId)
            })
         })
      },

      data () {
         return {
            selectedModuleId: null,
         }
      },

      computed: {
         user() {
            return this.$store.state.users[this.userId]
         },
         teams() {
            if (this.$store.state.teams.user2teamList.hasOwnProperty(this.userId)) {
               return this.$store.state.teams.user2teamList[this.userId].map(teamId => this.$store.state.teams.teams[teamId])
            } else {
               return []
            }
         },
         selectedModule () {
            return this.$store.state.shdl.modules[this.selectedModuleId]
         },
      },

      methods: {
         
         selectModule (moduleId) {
            // make the module selected in ShdlModuleList
            this.selectedModuleId = moduleId
            // change route
            this.$router.push(`${this.baseRoute}module/${moduleId}/editor`)
            // post event that module has been accessed
            let module = this.$store.state.shdl.modules[moduleId]
            this.$store.dispatch('POST_HISTORY_EVENT', {
               author: this.$store.state.loggedUserId,
               user: this.user.id, // team = null
               message: { "text": "Accès au module " + module.name }
            })
         },
         unselectAll () {
            this.selectedModuleId = null
            // change route
            this.$router.push(this.baseRoute)
         },
         userModuleUpdated (moduleId) {
            this.$emit('userModuleUpdated', moduleId)
            this.selectedModuleId = moduleId
         },
         async addModule (name, teamId) {
            let moduleList = teamId ? this.$store.state.shdl.team2moduleList[teamId] : this.$store.state.shdl.user2moduleList[this.user.id]
            if (moduleList.map(moduleId => this.$store.state.shdl.modules[moduleId].name).indexOf(name) !== -1) {
               this.$store.commit('SNACKBAR', { timeout: 3500, text: "Un module de ce nom existe déjà", color: 'red' })
            } else {
               try {
                  let addedModule = await this.$store.dispatch('shdl/POST_SHDL_MODULE', {
                     name: name,
                     user: teamId ? null : this.user.id,
                     team: teamId ? teamId : null,
                     update_author: this.$store.state.loggedUserId,
                     text: `module ${name}()\nend module`,
                  })
                  this.selectModule(addedModule.id)
               } catch(e) {
                  this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de la création", color: 'red' })
               }
            }
         },
         async deleteModule (module) {
            try {
               await this.$store.dispatch('shdl/DELETE_SHDL_MODULE', module)
               await this.$store.dispatch('POST_HISTORY_EVENT', {
                  author: this.$store.state.loggedUserId,
                  user: this.user.id, // team = null
                  message: { "text": "Suppression du module " + module.name }
               })
               this.unselectAll()
            } catch(e) {
               this.$store.commit('SNACKBAR', { timeout: 3500, text: "Erreur lors de la suppression", color: 'red' })
            }
         },

         isModuleOk (module) {
            if (this.$store.state.shdl.module2parseInfo.hasOwnProperty(module.id)) {
               let parseInfo = this.$store.state.shdl.module2parseInfo[module.id]
               return parseInfo.isOk
            } else {
               return null
            }
         },

         async lockModule (module) {
            console.log("lock module", module)

            // check module and its submodules
            let name2module = {}
            let userOrTeamModuleIds = module.user ? this.$store.state.shdl.user2moduleList[module.user] : this.$store.state.shdl.team2moduleList[module.team]
            userOrTeamModuleIds.forEach((moduleId) => {
               let module = this.$store.state.shdl.modules[moduleId]
               name2module[module.name] = module
            })
            let { err, moduleList } = checkModule(module.name, name2module)
            console.log('moduleList', moduleList)

            // lock module and all its submodules
            try {
               moduleList.forEach(async module => {
                  let vuexModule = this.$store.state.shdl.modules[module.id]
                  vuexModule.locked_date = moment().format()
                  await this.$store.dispatch('shdl/PUT_SHDL_MODULE', vuexModule)
               })
            } catch(e) {
               this.$store.commit('SNACKBAR', { timeout: 3500, text: "Error while saving", color: 'red' })
            }
         },

      },
   };
</script>



// WEBPACK FOOTER //
// ShdlUserModules.vue?3e255338